import { render, staticRenderFns } from "./PlatformAccountSelect.vue?vue&type=template&id=21a0d2d4&"
import script from "./PlatformAccountSelect.vue?vue&type=script&lang=js&"
export * from "./PlatformAccountSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports